var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 10C16.0007 12.6667 14.134 14.9333 11.734 15.7333C11.2007 15.8667 10.6673 16 10.0007 16C9.71484 16 9.46732 15.9617 9.23757 15.9262C9.0386 15.8954 8.85296 15.8667 8.66732 15.8667C6.00065 15.2 4.00065 12.8 4.00065 10C4.00065 6.66667 6.66732 4 10.0007 4C13.334 4 16.0007 6.66667 16.0007 10ZM10.0007 6.66667C8.13398 6.66667 6.66732 8.13333 6.66732 10C6.66732 11.8667 8.13398 13.3333 10.0007 13.3333C11.8673 13.3333 13.334 11.8667 13.334 10C13.334 8.13333 11.8673 6.66667 10.0007 6.66667Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0006 10C28.0006 12.5333 25.8673 14.6667 23.334 14.6667C20.8006 14.6667 18.6673 12.5333 18.6673 10C18.6673 7.46667 20.8006 5.33333 23.334 5.33333C25.8673 5.33333 28.0006 7.46667 28.0006 10ZM25.334 10C25.334 8.93333 24.4006 8 23.334 8C22.2673 8 21.334 8.93333 21.334 10C21.334 11.0667 22.2673 12 23.334 12C24.4006 12 25.334 11.0667 25.334 10Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4006 18.1333C19.6006 17.2 21.2006 16.6667 23.0673 16.6667C27.0673 16.6667 30.6673 20 30.6673 22.6667C30.6673 23.3333 30.0006 24 29.334 24C28.534 24 28.0006 23.3333 28.0006 22.6667C28.0006 21.7333 25.8673 19.3333 23.0673 19.3333C22.134 19.3333 21.2006 19.6 20.4006 20C19.8673 19.3333 19.2006 18.6667 18.4006 18.1333Z",
    fill: "#6E6E6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66732 26.6667C3.46732 26.6667 4.00065 26.1333 4.00065 25.3333C4.00065 22.8 7.06732 20.6667 10.6673 20.6667C14.2673 20.6667 17.334 22.8 17.334 25.3333C17.334 26.1333 17.8673 26.6667 18.6673 26.6667C19.4673 26.6667 20.0007 26.1333 20.0007 25.3333C20.0007 21.3333 15.8673 18 10.6673 18C5.46732 18 1.33398 21.3333 1.33398 25.3333C1.33398 26.1333 1.86732 26.6667 2.66732 26.6667Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.a29f365648cd85cd3cbfed868fbadc86.svg";
export { ForwardRef as ReactComponent };